import React from 'react';

import { Form, Input, Button } from 'antd';

const getLabel = (op) => {
  return `${op.name} ${op.symbol}`;
};

const FormItem = Form.Item;

const OperationForm = (props) => {
  const { getFieldDecorator } = props.form;
  const op = props.operation;

  return (
    <Form
      name={op.name}
      id={op.name}
      key={op.name}
      layout="inline"
      onSubmit={(e) => {
        e.preventDefault();
        props.form.validateFields((err, values) => {
          if (!err) {
            values.type = op.type;
            props.onUpdate(values);
            props.form.resetFields();
          }
        });
      }}
    >
      {getFieldDecorator('operationId', {
        initialValue: op.name,
      })(<Input type="hidden" />)}

      <FormItem label={getLabel(op)}>
        {getFieldDecorator('price', {
          initialValue: op.defaultValue,
          rules: [
            { required: true, message: 'Please provide a price' },
            { pattern: op.priceValidation.regexp, message: op.priceValidation.message },
          ],
        })(<Input placeholder="1" />)}
      </FormItem>

      <FormItem>
        <Button type="primary" htmlType="submit">
          Add Operation
        </Button>
      </FormItem>
    </Form>
  );
};

const AddOperationsList = ({ operations, onUpdate }) => (
  <div style={{ marginTop: '20px' }}>
    {operations.map((op) => {
      const OperationFormElement = Form.create()(OperationForm);
      return <OperationFormElement key={op.name} operation={op} onUpdate={onUpdate} />;
    })}
  </div>
);

export default AddOperationsList;
